import React, { Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Paper, Typography } from '@mui/material';
import { useStateIfMounted } from 'use-state-if-mounted';
import {
    guardarCambiosFC_05Solicitud,
    actualizarFC_05Estatus, resetDataFC_05,
    agregarMapFC_05Accion, actualizarFC_05Solicitud,
    obtenerIdCliente, actualizarFC_05,
    actualizarFC_05SolicitudMap, generarDocumentosFC_05
} from '../../../redux/DucksAtencionACliente/FC_05AtencionAClienteDucks';
import { AcualizarFormatoAccion } from '../../../redux/AtencionAClienteDucks'
import { withRouter } from 'react-router-dom'
import { host } from '../../../configuraciones'
import moment from 'moment'
import SaveIcon from '@mui/icons-material/Save';
import FormatClearIcon from '@mui/icons-material/FormatClear';
import IconButton from '@mui/material/IconButton';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../../redux/AppDucks';
import PaginacionAtencionAClientesComponent from '../../App/PaginacionAtencionAClientesComponent';
import TablaAtencionACliente from './TablaAtencionACliente';
import { obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado } from '../../../redux/DucksAtencionACliente/AtencionAClienteDucks';
import { obtenerTodasLasSolicitudesWithStatusEnviado } from '../../../redux/AtencionAClienteDucks'

import { v4 as uuidv4 } from 'uuid';
const { useState, useEffect, useRef } = React;
//import DocumentacionFC_05Component from './DocumentacionFC_05Component'
import estilosFC05 from './AtencionAClientesFC_05Component.module.css'; { {/*Estilos para el componente*/ } }
import TablaDocumentacion from '../../App/TablaDocumentacion';
import { obtenerClienteByIdLogin } from '../../../redux/DucksBeneficiario/ClienteDucks';
import { crearMetricas } from '../../../redux/DuckMetricas/MetricasDuck';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
const styleDevolver = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
const styleParaModalDeDocumentos = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    height: 290,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    color: 'black',
    p: 4,
    'overflowY': 'scroll',
};
function FC_05Component(props) {

    const dispatch = useDispatch()
    const usuario = useSelector(store => store.Usuario)
    const dataUser = useSelector(store => store.Usuario.user)
    var fechaHoy = moment().format('YYYY-MM-DD')
    const formato = useSelector(store => store.AtencionSolicitud.formato)
    let fc_05Map = useSelector(store => store.FC_05SolicitudAtencionACliente.fc_05Map)
    let solicitud = useSelector(store => store.FC_05SolicitudAtencionACliente.data)
    let filesMap = useSelector(store => store.FC_05SolicitudAtencionACliente.filesMap)
    const currentUser = useSelector(store => store.Usuario.data)
    const idUsuario = usuario.data.user[0].id
    let fecha = solicitud.fechasolicitud.substring(0, 10)
    let pagina1 = []
    {/*{
            id: uuidv4(), Campo: 'Nombre o Razón Social', valor: solicitud.nombrerazonsocial, idfc05_solicitudusomarcaeimagen: solicitud.idfc05_solicitudusomarcaeimagen,
            observaciones: '',
            correcto: false,
            incorrecto: false,
        },
        {
            id: uuidv4(), Campo: 'Teléfono', valor: solicitud.telefono, idfc05_solicitudusomarcaeimagen: solicitud.idfc05_solicitudusomarcaeimagen,
            observaciones: '',
            correcto: false,
            incorrecto: false,
        },
        {
            id: uuidv4(), Campo: 'Correo electrónico', valor: solicitud.correoelectronico, idfc05_solicitudusomarcaeimagen: solicitud.idfc05_solicitudusomarcaeimagen,
            observaciones: '',
            correcto: false,
            incorrecto: false,
        },*/}
    pagina1.push(
        {
            id: uuidv4(), Campo: 'Embalaje', valor: solicitud.embalaje ? 'Si' : 'No', idfc05_solicitudusomarcaeimagen: solicitud.idfc05_solicitudusomarcaeimagen,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_05Map) && JSON.stringify([]) !== JSON.stringify(fc_05Map) ? fc_05Map?.embalaje : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_05Map) && JSON.stringify([]) !== JSON.stringify(fc_05Map) ? !fc_05Map?.embalajecheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_05Map) && JSON.stringify([]) !== JSON.stringify(fc_05Map) ? fc_05Map?.embalajecheck : false,
        },
        {
            id: uuidv4(), Campo: 'Facturas', valor: solicitud.facturas ? 'Si' : 'No', idfc05_solicitudusomarcaeimagen: solicitud.idfc05_solicitudusomarcaeimagen,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_05Map) && JSON.stringify([]) !== JSON.stringify(fc_05Map) ? fc_05Map?.facturas : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_05Map) && JSON.stringify([]) !== JSON.stringify(fc_05Map) ? !fc_05Map?.facturascheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_05Map) && JSON.stringify([]) !== JSON.stringify(fc_05Map) ? fc_05Map?.facturascheck : false,
        },
        {
            id: uuidv4(), Campo: 'Folletos y/o Tríptico', valor: solicitud.folletostripticos ? 'Si' : 'No', idfc05_solicitudusomarcaeimagen: solicitud.idfc05_solicitudusomarcaeimagen,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_05Map) && JSON.stringify([]) !== JSON.stringify(fc_05Map) ? fc_05Map?.folletostripticos : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_05Map) && JSON.stringify([]) !== JSON.stringify(fc_05Map) ? !fc_05Map?.folletostripticoscheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_05Map) && JSON.stringify([]) !== JSON.stringify(fc_05Map) ? fc_05Map?.folletostripticoscheck : false,
        },
        {
            id: uuidv4(), Campo: 'Pagina web', valor: solicitud.paginaweb ? 'Si' : 'No', idfc05_solicitudusomarcaeimagen: solicitud.idfc05_solicitudusomarcaeimagen,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_05Map) && JSON.stringify([]) !== JSON.stringify(fc_05Map) ? fc_05Map?.paginaweb : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_05Map) && JSON.stringify([]) !== JSON.stringify(fc_05Map) ? !fc_05Map?.paginawebcheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_05Map) && JSON.stringify([]) !== JSON.stringify(fc_05Map) ? fc_05Map?.paginawebcheck : false,
        },
        {
            id: uuidv4(), Campo: 'Espectaculares', valor: solicitud.espectaculares ? 'Si' : 'No', idfc05_solicitudusomarcaeimagen: solicitud.idfc05_solicitudusomarcaeimagen,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_05Map) && JSON.stringify([]) !== JSON.stringify(fc_05Map) ? fc_05Map?.espectaculares : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_05Map) && JSON.stringify([]) !== JSON.stringify(fc_05Map) ? !fc_05Map?.espectacularescheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_05Map) && JSON.stringify([]) !== JSON.stringify(fc_05Map) ? fc_05Map?.espectacularescheck : false,
        },
        {
            id: uuidv4(), Campo: 'Rotulado en paredes', valor: solicitud.rotuladoparedes ? 'Si' : 'No', idfc05_solicitudusomarcaeimagen: solicitud.idfc05_solicitudusomarcaeimagen,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_05Map) && JSON.stringify([]) !== JSON.stringify(fc_05Map) ? fc_05Map?.rotuladoparedes : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_05Map) && JSON.stringify([]) !== JSON.stringify(fc_05Map) ? !fc_05Map?.rotuladoparedescheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_05Map) && JSON.stringify([]) !== JSON.stringify(fc_05Map) ? fc_05Map?.rotuladoparedescheck : false,
        },
        {
            id: uuidv4(), Campo: 'Otros documentos', valor: solicitud.otrosdocumentos ? 'Si' : 'No', idfc05_solicitudusomarcaeimagen: solicitud.idfc05_solicitudusomarcaeimagen,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_05Map) && JSON.stringify([]) !== JSON.stringify(fc_05Map) ? fc_05Map?.otrosdocumentos : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_05Map) && JSON.stringify([]) !== JSON.stringify(fc_05Map) ? !fc_05Map?.otrosdocumentoscheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_05Map) && JSON.stringify([]) !== JSON.stringify(fc_05Map) ? fc_05Map?.otrosdocumentoscheck : false,
        },
        {
            id: uuidv4(), Campo: 'Detalle Otro Documento', valor: solicitud.especificacionesotrosdocumentos !== null ? solicitud.especificacionesotrosdocumentos : '', idfc05_solicitudusomarcaeimagen: solicitud.idfc05_solicitudusomarcaeimagen,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_05Map) && JSON.stringify([]) !== JSON.stringify(fc_05Map) ? fc_05Map?.especificacionesotrosdocumentos : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_05Map) && JSON.stringify([]) !== JSON.stringify(fc_05Map) ? !fc_05Map?.especificacionesotrosdocumentoscheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_05Map) && JSON.stringify([]) !== JSON.stringify(fc_05Map) ? fc_05Map?.especificacionesotrosdocumentoscheck : false,
        },
    )
    let [rowspagina1, setRowsPagina1] = React.useState(pagina1)

    let pagina2 = []
    for (const i in solicitud.fc_05archivos) {
        let nameid = ''
        let nombre = ''
        if (solicitud.fc_05archivos?.[i].nameid === "DGEM" && solicitud.embalaje) {
            nameid = "DGEM", nombre = "Embalaje"
            let filtro = solicitud.fc_05archivos.filter(anexos => anexos.nameid === nameid)
            const filtroMap = filesMap?.filter(anexo => anexo.idfc_05archivos === filtro[0]?.idfc_05archivos)
            pagina2.push({
                id: uuidv4(),
                observaciones: filtroMap?.[0] ? filtroMap?.[0]?.observacion : '',
                correcto: filtroMap?.[0] ? !filtroMap?.[0]?.estatuscheck : false,
                incorrecto: filtroMap?.[0] ? filtroMap[0]?.estatuscheck : false,
                fechaInicio: filtro?.[0]?.fechainicio ? filtro?.[0]?.fechainicio : '',
                fechaTermino: filtro?.[0]?.fechafin ? filtro?.[0]?.fechafin : '',
                estatus: filtro?.[0]?.estatus ? filtro?.[0]?.estatus : 'Agregar',
                idMap: filtroMap?.[0] ? filtroMap?.[0]?.idfc_05archivosmap : '',
                idfc_05archivos: filtro?.[0]?.idfc_05archivos,
                tabla: 'fc_05archivos', nombreId: 'idfc05_solicitudusomarcaeimagen', idSolicitud: solicitud.idfc05_solicitudusomarcaeimagen,
                nameid: nameid, nameDoc: nombre
            })
        }
        if (solicitud.fc_05archivos?.[i].nameid === "DGFA" && solicitud.facturas) {
            nameid = "DGFA", nombre = "Factura"
            let filtro = solicitud.fc_05archivos.filter(anexos => anexos.nameid === nameid)
            const filtroMap = filesMap?.filter(anexo => anexo.idfc_05archivos === filtro[0]?.idfc_05archivos)
            pagina2.push({
                id: uuidv4(),
                observaciones: filtroMap?.[0] ? filtroMap?.[0]?.observacion : '',
                correcto: filtroMap?.[0] ? !filtroMap?.[0]?.estatuscheck : false,
                incorrecto: filtroMap?.[0] ? filtroMap[0]?.estatuscheck : false,
                fechaInicio: filtro?.[0]?.fechainicio ? filtro?.[0]?.fechainicio : '',
                fechaTermino: filtro?.[0]?.fechafin ? filtro?.[0]?.fechafin : '',
                estatus: filtro?.[0]?.estatus ? filtro?.[0]?.estatus : 'Agregar',
                idMap: filtroMap?.[0] ? filtroMap?.[0]?.idfc_05archivosmap : '',
                idfc_05archivos: filtro?.[0]?.idfc_05archivos,
                tabla: 'fc_05archivos', nombreId: 'idfc05_solicitudusomarcaeimagen', idSolicitud: solicitud.idfc05_solicitudusomarcaeimagen,
                nameid: nameid, nameDoc: nombre
            })
        }
        if (solicitud.fc_05archivos?.[i].nameid === "DGFT" && solicitud.folletostripticos) {
            nameid = "DGFT", nombre = 'Folletos y/o Tríptico'
            let filtro = solicitud.fc_05archivos.filter(anexos => anexos.nameid === nameid)
            const filtroMap = filesMap?.filter(anexo => anexo.idfc_05archivos === filtro[0]?.idfc_05archivos)
            pagina2.push({
                id: uuidv4(),
                observaciones: filtroMap?.[0] ? filtroMap?.[0]?.observacion : '',
                correcto: filtroMap?.[0] ? !filtroMap?.[0]?.estatuscheck : false,
                incorrecto: filtroMap?.[0] ? filtroMap[0]?.estatuscheck : false,
                fechaInicio: filtro?.[0]?.fechainicio ? filtro?.[0]?.fechainicio : '',
                fechaTermino: filtro?.[0]?.fechafin ? filtro?.[0]?.fechafin : '',
                estatus: filtro?.[0]?.estatus ? filtro?.[0]?.estatus : 'Agregar',
                idMap: filtroMap?.[0] ? filtroMap?.[0]?.idfc_05archivosmap : '',
                idfc_05archivos: filtro?.[0]?.idfc_05archivos,
                tabla: 'fc_05archivos', nombreId: 'idfc05_solicitudusomarcaeimagen', idSolicitud: solicitud.idfc05_solicitudusomarcaeimagen,
                nameid: nameid, nameDoc: nombre
            })
        }
        if (solicitud.fc_05archivos?.[i].nameid === "DGPW" && solicitud.paginaweb) {
            nameid = "DGPW", nombre = 'Pagina Web'
            let filtro = solicitud.fc_05archivos.filter(anexos => anexos.nameid === nameid)
            const filtroMap = filesMap?.filter(anexo => anexo.idfc_05archivos === filtro[0]?.idfc_05archivos)
            pagina2.push({
                id: uuidv4(),
                observaciones: filtroMap?.[0] ? filtroMap?.[0]?.observacion : '',
                correcto: filtroMap?.[0] ? !filtroMap?.[0]?.estatuscheck : false,
                incorrecto: filtroMap?.[0] ? filtroMap[0]?.estatuscheck : false,
                fechaInicio: filtro?.[0]?.fechainicio ? filtro?.[0]?.fechainicio : '',
                fechaTermino: filtro?.[0]?.fechafin ? filtro?.[0]?.fechafin : '',
                estatus: filtro?.[0]?.estatus ? filtro?.[0]?.estatus : 'Agregar',
                idMap: filtroMap?.[0] ? filtroMap?.[0]?.idfc_05archivosmap : '',
                idfc_05archivos: filtro?.[0]?.idfc_05archivos,
                tabla: 'fc_05archivos', nombreId: 'idfc05_solicitudusomarcaeimagen', idSolicitud: solicitud.idfc05_solicitudusomarcaeimagen,
                nameid: nameid, nameDoc: nombre
            })
        }
        if (solicitud.fc_05archivos?.[i].nameid === "DGES" && solicitud.espectaculares) {
            nameid = "DGES", nombre = "Espectaculares"
            let filtro = solicitud.fc_05archivos.filter(anexos => anexos.nameid === nameid)
            const filtroMap = filesMap?.filter(anexo => anexo.idfc_05archivos === filtro[0]?.idfc_05archivos)
            pagina2.push({
                id: uuidv4(),
                observaciones: filtroMap?.[0] ? filtroMap?.[0]?.observacion : '',
                correcto: filtroMap?.[0] ? !filtroMap?.[0]?.estatuscheck : false,
                incorrecto: filtroMap?.[0] ? filtroMap[0]?.estatuscheck : false,
                fechaInicio: filtro?.[0]?.fechainicio ? filtro?.[0]?.fechainicio : '',
                fechaTermino: filtro?.[0]?.fechafin ? filtro?.[0]?.fechafin : '',
                estatus: filtro?.[0]?.estatus ? filtro?.[0]?.estatus : 'Agregar',
                idMap: filtroMap?.[0] ? filtroMap?.[0]?.idfc_05archivosmap : '',
                idfc_05archivos: filtro?.[0]?.idfc_05archivos,
                tabla: 'fc_05archivos', nombreId: 'idfc05_solicitudusomarcaeimagen', idSolicitud: solicitud.idfc05_solicitudusomarcaeimagen,
                nameid: nameid, nameDoc: nombre
            })
        }
        if (solicitud.fc_05archivos?.[i].nameid === "DGRP" && solicitud.rotuladoparedes) {
            nameid = "DGRP", nombre = "Rotulado Paredes"
            let filtro = solicitud.fc_05archivos.filter(anexos => anexos.nameid === nameid)
            const filtroMap = filesMap?.filter(anexo => anexo.idfc_05archivos === filtro[0]?.idfc_05archivos)
            pagina2.push({
                id: uuidv4(),
                observaciones: filtroMap?.[0] ? filtroMap?.[0]?.observacion : '',
                correcto: filtroMap?.[0] ? !filtroMap?.[0]?.estatuscheck : false,
                incorrecto: filtroMap?.[0] ? filtroMap[0]?.estatuscheck : false,
                fechaInicio: filtro?.[0]?.fechainicio ? filtro?.[0]?.fechainicio : '',
                fechaTermino: filtro?.[0]?.fechafin ? filtro?.[0]?.fechafin : '',
                estatus: filtro?.[0]?.estatus ? filtro?.[0]?.estatus : 'Agregar',
                idMap: filtroMap?.[0] ? filtroMap?.[0]?.idfc_05archivosmap : '',
                idfc_05archivos: filtro?.[0]?.idfc_05archivos,
                tabla: 'fc_05archivos', nombreId: 'idfc05_solicitudusomarcaeimagen', idSolicitud: solicitud.idfc05_solicitudusomarcaeimagen,
                nameid: nameid, nameDoc: nombre
            })
        }
        if (solicitud.fc_05archivos?.[i].nameid === "DGOD" && solicitud.otrosdocumentos) {
            nameid = "DGOD", nombre = "Otros Documentos"
            let filtro = solicitud.fc_05archivos.filter(anexos => anexos.nameid === nameid)
            const filtroMap = filesMap?.filter(anexo => anexo.idfc_05archivos === filtro[0]?.idfc_05archivos)
            pagina2.push({
                id: uuidv4(),
                observaciones: filtroMap?.[0] ? filtroMap?.[0]?.observacion : '',
                correcto: filtroMap?.[0] ? !filtroMap?.[0]?.estatuscheck : false,
                incorrecto: filtroMap?.[0] ? filtroMap[0]?.estatuscheck : false,
                fechaInicio: filtro?.[0]?.fechainicio ? filtro?.[0]?.fechainicio : '',
                fechaTermino: filtro?.[0]?.fechafin ? filtro?.[0]?.fechafin : '',
                estatus: filtro?.[0]?.estatus ? filtro?.[0]?.estatus : 'Agregar',
                idMap: filtroMap?.[0] ? filtroMap?.[0]?.idfc_05archivosmap : '',
                idfc_05archivos: filtro?.[0]?.idfc_05archivos,
                tabla: 'fc_05archivos', nombreId: 'idfc05_solicitudusomarcaeimagen', idSolicitud: solicitud.idfc05_solicitudusomarcaeimagen,
                nameid: nameid, nameDoc: nombre
            })
        }

    }
    let [rowspagina2, setRowsPagina2] = React.useState(pagina2)


    const [paginaActiva, setPaginaActiva] = useStateIfMounted(1)
    const [paginas, setPaginas] = useStateIfMounted([1, 2])
    const modoVerDetalle = useSelector(store => store.FC_05SolicitudAtencionACliente.modoVerDetalle)
    const [nombresParaPaginas, setNombresParaPaginas] = useStateIfMounted(['Datos solicitante', 'Documentación'])
    const cambiarPagina = (pagina) => {
        setPaginaActiva(pagina)
    }
    const handdleEditPrev = (objectProducto) => {
        const filtroGeneral = rowspagina1.findIndex(anexo => anexo.id === objectProducto.id)
        const filtroDocumentacion = rowspagina2.findIndex(anexo => anexo.id === objectProducto.id)
        if (filtroGeneral !== -1) {
            rowspagina1[filtroGeneral].valor = objectProducto.valor
            rowspagina1[filtroGeneral].correcto = objectProducto.correcto
            rowspagina1[filtroGeneral].incorrecto = objectProducto.incorrecto
            rowspagina1[filtroGeneral].observaciones = objectProducto.observaciones
        }
        if (filtroDocumentacion !== -1) {
            rowspagina2[filtroDocumentacion].valor = objectProducto.valor
            rowspagina2[filtroDocumentacion].correcto = objectProducto.correcto
            rowspagina2[filtroDocumentacion].incorrecto = objectProducto.incorrecto
            rowspagina2[filtroDocumentacion].observaciones = objectProducto.observaciones
        }
    }

    const botonDevolverSolicitud = async () => {
        await dispatch(actualizarLoadingApp_true())
        if (JSON.stringify({}) === JSON.stringify(fc_05Map) || JSON.stringify([]) === JSON.stringify(fc_05Map) || fc_05Map === null) {
            await agregarMapYActualizarFC_05()
            const idSolicitud = solicitud.idfc05_solicitudusomarcaeimagen
            const estatusNuevo = 5
            const idCliente = null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_05 = 1
            const tabla = tablaFC_05
            await dispatch(actualizarFC_05Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: solicitud.folio } }
            ))
        } else {
            await actualizarMapYActualizarFC_05()
            const idSolicitud = solicitud.idfc05_solicitudusomarcaeimagen
            const estatusNuevo = 5
            const idCliente = null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_05 = 1
            const tabla = tablaFC_05
            await dispatch(actualizarFC_05Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: solicitud.folio } }
            ))
        }
        await dispatch(actualizarLoadingApp_false())
        props.history.push('/AtencionAClientesComponent')

    }
    const agregarMapYActualizarFC_05 = async () => {
        let principal = []
        const fechaHoy = moment().format('YYYY-MM-DD')
        let fechaSolicitudAceptada = new Date(fechaHoy).toISOString()
        principal.push({
            idfc05_solicitudusomarcaeimagen: solicitud.idfc05_solicitudusomarcaeimagen,
            fechasolicitud: fechaSolicitudAceptada, embalaje: rowspagina1[0].valor == 'Si' ? true : false,
            facturas: rowspagina1[1].valor == 'Si' ? true : false, folletostripticos: rowspagina1[2].valor == 'Si' ? true : false,
            paginaweb: rowspagina1[3].valor == 'Si' ? true : false, espectaculares: rowspagina1[4].valor == 'Si' ? true : false,
            rotuladoparedes: rowspagina1[5].valor == 'Si' ? true : false, otrosdocumentos: rowspagina1[6].valor == 'Si' ? true : false,
            especificacionesotrosdocumentos: rowspagina1[7].valor,
        })
        let datosPricipalMap = []
        for (const dato of rowspagina1) {
            if (dato.Campo === 'Embalaje') datosPricipalMap.push({ embalaje: dato.observaciones, embalajecheck: dato.incorrecto })
            if (dato.Campo === 'Facturas') datosPricipalMap.push({ facturas: dato.observaciones, facturascheck: dato.incorrecto })
            if (dato.Campo === 'Folletos y/o Tríptico') datosPricipalMap.push({ folletostripticos: dato.observaciones, folletostripticoscheck: dato.incorrecto })
            if (dato.Campo === 'Pagina web') datosPricipalMap.push({ paginaweb: dato.observaciones, paginawebcheck: dato.incorrecto })
            if (dato.Campo === 'Espectaculares') datosPricipalMap.push({ espectaculares: dato.observaciones, espectacularescheck: dato.incorrecto })
            if (dato.Campo === 'Rotulado en paredes') datosPricipalMap.push({ rotuladoparedes: dato.observaciones, rotuladoparedescheck: dato.incorrecto })
            if (dato.Campo === 'Otros documentos') datosPricipalMap.push({ otrosdocumentos: dato.observaciones, otrosdocumentoscheck: dato.incorrecto })
            if (dato.Campo === 'Detalle Otro Documento') datosPricipalMap.push({ especificacionesotrosdocumentos: dato.observaciones, especificacionesotrosdocumentoscheck: dato.incorrecto })
        }
        let obj_unidos = {}
        for (const i in datosPricipalMap) {
            obj_unidos = Object.assign(obj_unidos, datosPricipalMap[i])
        }
        obj_unidos.idfc05_solicitudusomarcaeimagen = solicitud.idfc05_solicitudusomarcaeimagen
        let archivosMap = []
        for (const anexo in rowspagina2) {
            archivosMap.push({
                estatuscheck: rowspagina2[anexo]?.incorrecto, observacion: rowspagina2[anexo]?.observaciones,
                idfc_05archivos: rowspagina2[anexo]?.idfc_05archivos,
            })
        }
        let archivos = []
        for (const anexo in rowspagina2) {
            let fechaInicio = ''
            let fechaFin = ''
            if (rowspagina2[anexo]?.fechaInicio.length > 0) fechaInicio = new Date(rowspagina2[anexo]?.fechaInicio).toISOString()
            else fechaInicio = null
            if (rowspagina2[anexo]?.fechaTermino.length > 0) fechaFin = new Date(rowspagina2[anexo]?.fechaTermino).toISOString()
            else fechaFin = null
            archivos.push({
                fechainicio: fechaInicio, fechafin: fechaFin, idfc05_solicitudusomarcaeimagen: rowspagina2[anexo]?.idSolicitud,
                idfc_05archivos: rowspagina2[anexo]?.idfc_05archivos,
            })
        }
        let formato = { solicitud: principal[0], archivos: archivos }
        let formatoMap = { solicitud: obj_unidos, archivosMap: archivosMap }
        await dispatch(agregarMapFC_05Accion(formatoMap))
        let res = await dispatch(actualizarFC_05Solicitud(formato))
        return res
    }
    const actualizarMapYActualizarFC_05 = async () => {
        let principal = []
        const fechaHoy = moment().format('YYYY-MM-DD')
        let fechaSolicitudAceptada = new Date(fechaHoy).toISOString()
        principal.push({
            idfc05_solicitudusomarcaeimagen: solicitud.idfc05_solicitudusomarcaeimagen,
            fechasolicitud: fechaSolicitudAceptada, embalaje: rowspagina1[0].valor == 'Si' ? true : false,
            facturas: rowspagina1[1].valor == 'Si' ? true : false, folletostripticos: rowspagina1[2].valor == 'Si' ? true : false,
            paginaweb: rowspagina1[3].valor == 'Si' ? true : false, espectaculares: rowspagina1[4].valor == 'Si' ? true : false,
            rotuladoparedes: rowspagina1[5].valor == 'Si' ? true : false, otrosdocumentos: rowspagina1[6].valor == 'Si' ? true : false,
            especificacionesotrosdocumentos: rowspagina1[7].valor,
        })
        let datosPricipalMap = []
        for (const dato of rowspagina1) {
            if (dato.Campo === 'Embalaje') datosPricipalMap.push({ embalaje: dato.observaciones, embalajecheck: dato.incorrecto })
            if (dato.Campo === 'Facturas') datosPricipalMap.push({ facturas: dato.observaciones, facturascheck: dato.incorrecto })
            if (dato.Campo === 'Folletos y/o Tríptico') datosPricipalMap.push({ folletostripticos: dato.observaciones, folletostripticoscheck: dato.incorrecto })
            if (dato.Campo === 'Pagina web') datosPricipalMap.push({ paginaweb: dato.observaciones, paginawebcheck: dato.incorrecto })
            if (dato.Campo === 'Espectaculares') datosPricipalMap.push({ espectaculares: dato.observaciones, espectacularescheck: dato.incorrecto })
            if (dato.Campo === 'Rotulado en paredes') datosPricipalMap.push({ rotuladoparedes: dato.observaciones, rotuladoparedescheck: dato.incorrecto })
            if (dato.Campo === 'Otros documentos') datosPricipalMap.push({ otrosdocumentos: dato.observaciones, otrosdocumentoscheck: dato.incorrecto })
            if (dato.Campo === 'Detalle Otro Documento') datosPricipalMap.push({ especificacionesotrosdocumentos: dato.observaciones, especificacionesotrosdocumentoscheck: dato.incorrecto })
        }
        let obj_unidos = {}
        for (const i in datosPricipalMap) {
            obj_unidos = Object.assign(obj_unidos, datosPricipalMap[i])
        }
        obj_unidos.idfc05_solicitudusomarcaeimagen = solicitud.idfc05_solicitudusomarcaeimagen
        obj_unidos.idfc05_solicitudusomarcaeimagenmap = fc_05Map.idfc05_solicitudusomarcaeimagenmap
        let archivosMap = []
        for (const anexo in rowspagina2) {
            archivosMap.push({
                estatuscheck: rowspagina2[anexo]?.incorrecto, observacion: rowspagina2[anexo]?.observaciones,
                idfc_05archivos: rowspagina2[anexo]?.idfc_05archivos, idfc_05archivosmap: rowspagina2[anexo]?.idMap,
            })
        }

        let archivos = []
        for (const anexo in rowspagina2) {
            let fechaInicio = ''
            let fechaFin = ''
            if (rowspagina2[anexo]?.fechaInicio.length > 0) fechaInicio = new Date(rowspagina2[anexo]?.fechaInicio).toISOString()
            else fechaInicio = null
            if (rowspagina2[anexo]?.fechaTermino.length > 0) fechaFin = new Date(rowspagina2[anexo]?.fechaTermino).toISOString()
            else fechaFin = null
            archivos.push({
                fechainicio: fechaInicio, fechafin: fechaFin, idfc05_solicitudusomarcaeimagen: rowspagina2[anexo]?.idSolicitud,
                idfc_05archivos: rowspagina2[anexo]?.idfc_05archivos,
            })
        }
        let formato = { solicitud: principal[0], archivos: archivos }
        let formatoMap = { solicitud: obj_unidos, archivosMap: archivosMap }
        await dispatch(actualizarFC_05SolicitudMap(formatoMap))
        let res = await dispatch(actualizarFC_05Solicitud(formato))
        return res
    }
    const [openModalAceptar, setOpenModalAceptar] = React.useState(false);
    const [dataModal, setDataModal] = React.useState('')
    const handleOpenModalAceptar = () => setOpenModalAceptar(true);
    const handleCloseModalAceptar = () => setOpenModalAceptar(false);
    const modalComponentAceptar = () => {
        return (
            <div>
                <Modal
                    open={openModalAceptar}
                    onClose={handleCloseModalAceptar}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={styleParaModalDeDocumentos}>
                        <Typography id="modal-modal-title" variant="h6" component="h2" color="black !important" align='center'>
                            <strong>Aceptar Solicitud</strong>
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }} style={{ textAlign: 'justify' }}>
                            Está a punto de aceptar la solicitud, ya no podrá seguir revisándola
                            y los datos se tomarán como válidos.
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }} style={{ textAlign: 'center' }}>
                            <strong>¿Desea continuar?</strong>
                        </Typography>
                        <div className='row'>
                            <button className='btn btn-success' onClick={() => botonAceptarSolicitud()}>CONTINUAR</button>
                        </div>

                        <br />
                    </Box>
                </Modal>
            </div>

        )
    }
    const botonAceptarSolicitud = async () => {
        await dispatch(actualizarLoadingApp_true())
        let result = []
        if (JSON.stringify({}) === JSON.stringify(fc_05Map) || JSON.stringify([]) === JSON.stringify(fc_05Map) || fc_05Map === null) {
            result = await agregarMapYActualizarFC_05()
        } else {
            result = await actualizarMapYActualizarFC_05()
        }
        let dataMetricas = {
            estatus_procedencia: "Solicitudes Recibidas Procedentes",
            fecha: moment().format('YYYY-MM-DD HH:mm:ss'), id_solicitud: "2", id_usuario: dataUser?.[0].idlogin,
            motivo: "Cargado automatico del sistema",
            numero_cliente: solicitud?.numerocliente,
            numero_solicitud: '', origen: "Sistema"
        }
        await dispatch(crearMetricas(dataMetricas))
        const dataCliente = await dispatch(obtenerClienteByIdLogin(solicitud.idlogin))
        await generarOficios(result?.payload?.data?.data, dataCliente.payload.cliente[0])
        const idSolicitud = solicitud.idfc05_solicitudusomarcaeimagen
        const estatusNuevo = 4
        const idCliente = null
        const tablaFC_05 = 1
        const tabla = tablaFC_05
        await dispatch(actualizarFC_05Estatus(
            { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: solicitud.folio } }
        ))
        const idRol = currentUser.user[0].rol
        if (idRol === 1) await dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 4 }))
        else if (idRol === 2) await dispatch(obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado({ status: 4, revisor: dataUser[0]?.datoslogin.nombre + ' ' + dataUser[0]?.datoslogin.apellidos, idLogin: currentUser.user[0].id }))
        await dispatch(actualizarLoadingApp_false())
        props.history.push('/AtencionAClientesComponent')
    }
    const generarOficios = async (solicitudFC_05, dataCliente) => {
        const data = {
            tipoSolicitud: 'FC_05',
            solicitudFC_05,
            dataCliente,
        }
        await dispatch(generarDocumentosFC_05(data))
    }
    const botonRegresar = async () => {
        props.history.push('/AtencionAClientesComponent')
        await dispatch(resetDataFC_05())
    }
    const [openModalDevolver, setOpenModalDevolver] = React.useState(false);
    const handleOpenModalDevolver = (params) => {
        setOpenModalDevolver(true)
    }
    const handleCloseModalDevolver = () => {
        setOpenModalDevolver(false)

    }
    const modalComponentDevolver = () => {
        return (
            <div>
                <Modal
                    open={openModalDevolver}
                    onClose={handleCloseModalDevolver}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    hideBackdrop={true}
                >
                    <Box sx={styleDevolver}>

                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <center>¡Advertencia!</center>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }}>
                            <p>Está a punto de devolver esta solicitud.
                                Las observaciones seran enviadas al cliente para correcciones.</p>
                            <br /> <center><strong>¿Desea continuar?</strong></center>
                        </Typography>
                        <br />

                        <div className='row'>
                            <div className='col-md-6'>
                                <button className='btn btn-outline-success' onClick={() => { botonDevolverSolicitud() }}>CONTINUAR</button>
                            </div>
                            <div className={` col-md-2`}>
                                <button className='btn btn-outline-danger' onClick={() => { handleCloseModalDevolver() }}>CANCELAR</button>
                            </div>
                        </div>

                    </Box>
                </Modal>
            </div>
        )
    }
    return (
        <Fragment>
            <div className='text-center'>
                <PaginacionAtencionAClientesComponent paginas={paginas} nombreParaPaginas={nombresParaPaginas} paginaActiva={paginaActiva} cambiarPagina={cambiarPagina} />
            </div>
            {
                nombresParaPaginas[paginaActiva - 1] === 'Datos solicitante' ?
                    <div className='row justify-content-center'>
                        <div className='col-10'>
                            <TablaAtencionACliente rows={rowspagina1} api={{ handdleEditPrev }}></TablaAtencionACliente>
                        </div>
                    </div> :

                    <div className='row'>
                        <div className='row justify-content-center'>
                            <div className='col-12' style={{ marginLeft: '7%' }}>
                                <TablaDocumentacion rows={rowspagina2} api={{ handdleEditPrev }}></TablaDocumentacion>
                            </div>
                        </div>

                        {modoVerDetalle ?
                            <div className="row text-center">
                                <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                    <button type="submit" className={`btn ${estilosFC05.botonNaranjaRedondo}`} onClick={botonRegresar} >Regresar</button>
                                </div>
                            </div>
                            :
                            <div className="row text-center mt-4 mb-4">
                                <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                    <button type="submit" className={`btn ${estilosFC05.botonNaranjaRedondo}`} onClick={handleOpenModalAceptar} >Aceptar solicitud</button>
                                </div>

                                <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                    <button type="submit" className={`btn ${estilosFC05.botonNaranjaRedondo}`} onClick={handleOpenModalDevolver} >Devolver solicitud</button>
                                </div>
                            </div>
                        }
                    </div>
            }
            {modalComponentDevolver()}
            {modalComponentAceptar()}
        </Fragment>
    )
}
//export default withRouter(FC_05Component)
export default FC_05Component
